export default "__VITE_ASSET__CbKZbSx9__"